module.exports = __webpack_public_path__ + "img/198.19004e4c.jpg";